import React from 'react';

import ProjectsGraphQlController from '../../../../controllers/projectsGraphQl';
import { gql } from '@apollo/client';
import ShootsListTableRow from '../../../components/shootListTableRow';
import _, { forEach } from 'lodash';
import LoadingBar from '../../../components/global/loadingBar';
import Modal from '../../../components/modals';
// import LoadingBar from '../../../components/global/loadingBar'
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from 'moment';
import Select, { components } from 'react-select';
import ProjectTable from '../../../components/projectTable';
// import { ReactComponent as Down } from /svg/down-arrow-search.svg'
import { ReactComponent as Down } from '../../../../assets/svg/down-arrow-search.svg';
import { ReactComponent as Open } from '../../../../assets/svg/open.svg';
import { withRouter } from '../../../../services/withRoute';

const getVendorEventsList = gql`
	query VendorEventsList($filters: VendorEventsListFiltersInput, $vendorId: String!) {
		vendorEventsList(filters: $filters) {
			data {
				id
				tenantId
				projectId
				name
				projectSlNo
				slNo
				category
				crew {
					count
					role
					managerIds
					subRole
					userIds
					__typename
				}
				crewNew {
					userId
					roles {
						role
						subRole
					}
					isManager
					isCustomUser
				}
				city
				venue
				date
				outStation
				time
				flagLabel
				reportingTime
				durationInHrs
				dateOverlap
				dateTimeOverlap
				parentEvent_id
				projectTitle
				parentEventName
				childEvents {
					_id
					expenses {
						_id
						amount
						billTo
						billDate
						currency
						__typename
					}
					name
					parentEvent_id
					__typename
				}
				memoryCards {
					status
					isReceived
					__typename
				}
				equipments {
					isReceived
					status
					__typename
				}
				additionalServices {
					type
					_id
					__typename
				}
				__typename
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			nextPage
			__typename
		}
		vendorInfo(vendorId: $vendorId) {
			id
			businessName
			vendorId
			associatedTenants {
				_id
				workspaceId
				workspaceKey
				__typename
			}
			isSuperHuemn
			__typename
		}
		vendorUsers {
			isShooter
			isSuspended
			lastName
			isEmailVerified
			firstName
			id
			displayName
			phoneNumber
			accessibleTenants {
				tenant_id
				workspaceId
				role
				walletBalance
			}
		}
	}
`;

class ShowShootOverviewDetails extends ProjectsGraphQlController {
	constructor() {
		super();
		this.state = {
			showEventModal: false,
			shootList: [],
			limit: 15,
			page: 1,
			currentViewPage: 1,
			totalPages: 1,
			lengthOfList: 0,
			startDate: null,
			endDate: null,
			lengthOfList: 0,
			hasNextPage: true,
			columns: [
				{ title: 'TIME / CITY' },
				{ title: 'Shoot' },
				{ title: 'CP' },
				{ title: 'TP' },
				{ title: 'CV' },
				{ title: 'TV' },
				{ title: 'EQ' },
				{ title: 'MC' },
				{ title: 'ADD SERVICES' },
				{ title: 'FEEDBACK' },
			],
		};
	}
	componentDidMount = async () => {};

	componentWillReceiveProps = async (nextProps) => {
		if (nextProps.eventDate !== this.props.eventDate) {
			let json = {
				filters: {
					page: this.state.page,
					limit: this.state.limit,
					startDate: parseInt(nextProps.eventDate),
					endDate: parseInt(nextProps.eventDate),
				},
				vendorId: this.props.vendorID,
			};
			this.setState({
				startDate: nextProps.eventDate,
				endDate: nextProps.eventDate,
			});
			this.getVendorEventsList(getVendorEventsList, json);
		}
	};

	handleCloseModal = () => {
		this.props.handleClose();
	};
	getWorkspacename(tenantId, workspacesFilters) {
		for (let i = 0; i < workspacesFilters.length; i++) {
			if (workspacesFilters[i].key === tenantId) {
				return workspacesFilters[i].name;
			}
		}
		return '';
	}
	onClickNextPage = async () => {
		if (this.state.currentViewPage < this.state.totalPages) {
			this.setState(
				{
					currentViewPage: this.state.currentViewPage + 1,
				},
				async () => {
					await this.fetchMoreShoots();
				},
			);
		}
	};
	fetchMoreShoots = async () => {
		let json = {
			filters: {
				page: this.state.currentViewPage,
				limit: this.state.limit,
				startDate: parseInt(this.state.startDate),
				endDate: parseInt(this.state.endDate),
			},
			vendorId: this.props.vendorID,
		};

		this.getVendorEventsList(getVendorEventsList, json);
	};
	render() {
		return (
			<Modal
				handleClose={() => this.handleCloseModal()}
				show={this.props.show}
				modalType={'center'}
				// isOverflowVisible={true}
			>
				<div className="busy-modal2">
					<div className="bm-header2">
						<div className="lefticon" style={{ marginLeft: '28px', cursor: 'pointer' }}>
							<span
								onClick={() => {
									this.setState({
										shootList: [],
									});
									this.props.handleClose();
								}}
								style={{ padding: '20px' }}
							>
								X
							</span>
						</div>
						<div className="modalheader">
							Shoot Schedule on {moment(this.props.eventDate).format('Do MMMM YYYY')}
						</div>
						<div
							className="rightside"
							style={{
								marginRight: '28px',
								display: 'flex',
								alignItems: 'center',
								gap: '10px',
							}}
						>
							<p> Open in New Tab</p>
							<Open />
						</div>
					</div>
					<div
						className={'table shoots-table'}
						id={'scrollableDiv-shoots-vendors'}
						style={{
							height: 'calc(90vh - 5px)',
							overflowY: 'auto',
							marginTop: '-100px',
						}}
					>
						<div>
							<InfiniteScroll
								dataLength={this.state.lengthOfList}
								next={() => {
									this.onClickNextPage();
								}}
								hasMore={this.state.hasNextPage}
								loader={
									<div
										style={{
											color: '#fff',
											textAlign: 'center',
											width: '100%',
											padding: '20px',
										}}
									>
										Loading...
									</div>
								}
								scrollableTarget={'scrollableDiv-shoots-vendors'}
							>
								<table
									className="shootTable2"
									style={{
										border: 'none',
										padding: '0px 20px',
									}}
								>
									<thead
										style={{
											position: 'sticky',
											top: '0px',
											/* make the table heads sticky */
										}}
									>
										<tr height={48}>
											{_.map(this.state.columns, (column, key) => {
												return (
													<th
														className={
															_.has(column, 'className')
																? column.className
																: 'all-other-column-fixed'
														}
													>
														<div className="th-header">
															{_.has(column, 'dummyPad') ? (
																<span
																	className="dummy-pad"
																	style={{
																		minWidth:
																			_.has(
																				column,
																				'dummyPad',
																			) &&
																			_.has(
																				column,
																				'dummyPadWidth',
																			)
																				? column.dummyPadWidth
																				: '',
																	}}
																></span>
															) : (
																''
															)}
															<p className="header-title">
																{column.title}{' '}
																{_.has(column, 'lineBreakTitle') ? (
																	<>
																		{' '}
																		<br />{' '}
																		{column.lineBreakTitle}
																	</>
																) : (
																	''
																)}
															</p>
															{_.has(column, 'sortBy') ? (
																<span
																	className={
																		'sort-icn' +
																		(this.state[
																			`${column.sortBy}SortType`
																		] == -1
																			? ' sort-visible'
																			: this.state[
																					`${column.sortBy}SortType`
																			  ] == 1
																			? ' sort-visible sort-ascending'
																			: ' sort-hidden')
																	}
																>
																	<Down />
																</span>
															) : (
																''
															)}
														</div>
													</th>
												);
											})}
										</tr>
									</thead>
									{this.state.shootList.length === 0 ? (
										<div
											style={{
												height: '250px',
											}}
										>
											<LoadingBar />
										</div>
									) : (
										<tbody>
											{/* <div
                                    className="wrapper"
                                    style={{
                                        height: '800px',
                                        overflow: 'scroll',
                                    }}
                                > */}
											{_.map(this.state.shootList, (shoot, idx) => {
												return (
													<tr
														style={{
															cursor: 'pointer',
														}}
														height={40}
														//onClick={this.props.handleShootClick}
														// className={
														//     this.state.showLinkedEvents
														//         ? 'no-border-row'
														//         : ''
														// }

														onClick={() => {
															let wstring = this.getWorkspacename(
																shoot.tenantId,
																this.state.workspacesFilters,
															);
															this.props.navigate(
																`/${this.props.vendorID}/shoots/${wstring}/${shoot.projectId}/${shoot.id}`,
															);
														}}
														ref={this.ref}
														// style={
														//     _.has(this.props, 'style')
														//         ? this.props.style
														//         : {}
														// }
													>
														{/* <td className="all-other-column-fixed">
						<ShootFlagDropdown
							flag={this.props.data.flagLabel}
							onFlagSelected={(flag) =>
								this.props.onFlagSelected(
									flag,
									this.props.data.tenantId,
									this.props.data.projectId,
									this.props.data.id,
								)
							}
							flagList={this.state.flagList}
						/>
					</td> */}
														<td
															// className="all-other-column-fixed"
															onClick={this.props.handleShootClick}
														>
															<div className="event-city-date-container">
																<div
																	// className="top-text-container"
																	// style={{ fontSize: '20px' }}
																	style={{
																		display: 'flex',
																		flexDirection: 'column',
																		gap: '10px',
																		textTransform: 'capitalize',
																	}}
																>
																	<div
																		style={{
																			display: 'flex',
																			gap: '5px',
																		}}
																	>
																		<p>
																			{' '}
																			<b
																				style={{
																					color: 'white',
																				}}
																			>
																				{shoot.city}
																			</b>
																		</p>
																		{shoot.outStation ? (
																			<span
																				style={{
																					backgroundColor:
																						'#0f72a3',
																					borderRadius:
																						'100px',
																					padding:
																						'1px 6px',
																					fontFamily:
																						'Inter',
																					fontStyle:
																						'normal',
																					fontWeight:
																						'500',
																					fontSize:
																						'11px',
																					lineHeight:
																						'16px',
																					textAlign:
																						'center',
																					letterSpacing:
																						'-0.3px',
																					color: '#ffffff',
																				}}
																			>
																				OS
																			</span>
																		) : (
																			''
																		)}
																	</div>
																	<p>
																		{shoot.time
																			? shoot.time
																			: '-'}
																	</p>
																</div>
															</div>
														</td>

														<td
															// className="all-other-column-fixed"
															onClick={this.props.handleShootClick}
														>
															<div className="eq-mc-outer-container">
																{/* {this.props.data.memoryCards === null ||
							_.size(this.props.data.memoryCards) === 0 ? null : (
								<span className="eq-mc-container">
									<span style={{ marginLeft: '5px' }}>
										{`${_.size(
											_.filter(this.props.data.memoryCards, {
												isReceived: true,
											}),
										)}
									/ ${_.size(this.props.data.memoryCards)}`}
									</span>
								</span>
							)} */}
																<span className="eq-mc-container">
																	<span
																		// style={{
																		//     marginLeft: '5px',
																		// }}
																		style={{
																			display: 'flex',
																			flexDirection: 'column',
																			gap: '10px',
																			textTransform:
																				'capitalize',
																		}}
																	>
																		<p>
																			<b
																				// className={
																				//     'starFilled' +
																				//     (e.dateOverlap
																				//         ? ' date-overlap'
																				//         : '') +
																				//     (e.dateTimeOverlap
																				//         ? ' date-time-overlap'
																				//         : '')
																				// }
																				style={{
																					color: 'white',
																				}}
																			>
																				{shoot.projectTitle}
																			</b>
																		</p>

																		<p>
																			<b>{shoot.name}</b>
																		</p>
																	</span>
																</span>
															</div>
														</td>

														<td className="wedding-details-column">
															<div className="event-city-date-container">
																<div
																	className="top-text-container shoot-list-city"
																	style={{
																		display: 'flex',
																		flexDirection: 'column',
																		textTransform: 'capitalize',
																	}}
																	onClick={(e) =>
																		_.has(
																			shoot,
																			'isProjectShootsList',
																		)
																			? ''
																			: this.handleProjectClick(
																					e,
																			  )
																	}
																>
																	{_.size(
																		_.filter(
																			shoot.crewDetails,
																			{
																				role: 'photographer',
																				subRole: 'candid',
																			},
																		),
																	) > 0
																		? _.filter(
																				shoot.crewDetails,
																				{
																					role: 'photographer',
																					subRole:
																						'candid',
																				},
																		  ).map((e, i) => {
																				return (
																					<b
																						className={
																							'starFilled' +
																							(e.dateOverlap
																								? ' date-overlap'
																								: '') +
																							(e.dateTimeOverlap
																								? ' date-time-overlap'
																								: '')
																						}
																						key={i}
																						style={{
																							background:
																								'none',
																							borderRadius: 0,
																							border: 'none',
																							height: 20,
																							padding: 0,
																						}}
																					>
																						<span
																							className="crew-name-text"
																							style={{
																								color: '#e4e5e6',
																							}}
																						>
																							{_.has(
																								e,
																								'displayName',
																							) &&
																							e.displayName !==
																								''
																								? e.displayName
																								: e.name}
																						</span>
																					</b>
																				);
																		  })
																		: '-'}
																</div>
																<div
																	className="top-text-container"
																	style={{
																		color: '#B0B0B0',
																	}}
																>
																	{/* <span
                                                style={{
                                                    color:
                                                        _.has(
                                                            this.props,
                                                            'isProjectShootsList'
                                                        ) &&
                                                        this.props
                                                            .isProjectShootsList ===
                                                            true
                                                            ? '#fff'
                                                            : '#B0B0B0',
                                                }}
                                            >
                                                <p>first event</p>
                                            </span> */}

																	{/* <span
                                                className="event-grouping-count"
                                                onClick={(e) => [
                                                    this.toggleShowLinkedEvents(
                                                        e
                                                    ),
                                                    e.stopPropagation(),
                                                ]}
                                            >
                                                <p>first event</p>
                                            </span> */}
																</div>
																{/* <div className="bottom-text-container">
								{_.filter(this.props.associatedTenants, {
									_id: this.props.data.tenantId,
								})[0]
									? _.filter(this.props.associatedTenants, {
											_id: this.props.data.tenantId,
									  })[0]['workspaceKey']
									: ''}
								{this.props.data.projectSlNo
									? `/ PJ-${this.props.data.projectSlNo}`
									: ''}
								{this.props.data.slNo ? `/ ST-${this.props.data.slNo}` : ''}
							</div> */}
															</div>
														</td>
														<td
															// className="all-other-column-fixed"
															onClick={this.props.handleShootClick}
														>
															<div className="project-general-box">
																<span className="crew-outer-container">
																	{/* <b
                                                className={
                                                    'starFilled' +
                                                    ' date-overlap' +
                                                    ' date-time-overlap'
                                                }
                                                // key={i}
                                                style={{
                                                    background: 'none',
                                                    borderRadius: 0,
                                                    border: 'none',
                                                    height: 20,
                                                    padding: 0,
                                                }}
                                            > */}
																	<span
																		className="crew-name-text"
																		style={{
																			color: '#e4e5e6',
																			display: 'flex',
																			flexDirection: 'column',
																			textTransform:
																				'capitalize',
																		}}
																	>
																		{_.size(
																			_.filter(
																				shoot.crewDetails,
																				{
																					role: 'photographer',
																					subRole:
																						'traditional',
																				},
																			),
																		) > 0
																			? _.filter(
																					shoot.crewDetails,
																					{
																						role: 'photographer',
																						subRole:
																							'traditional',
																					},
																			  ).map((e, i) => (
																					<b
																						className={
																							'starFilled' +
																							(e.dateOverlap
																								? ' date-overlap'
																								: '') +
																							(e.dateTimeOverlap
																								? ' date-time-overlap'
																								: '')
																						}
																						key={i}
																						style={{
																							background:
																								'none',
																							borderRadius: 0,
																							border: 'none',
																							height: 20,
																							padding: 0,
																						}}
																					>
																						<span
																							className="crew-name-text"
																							style={{
																								color: '#e4e5e6',
																							}}
																						>
																							{_.has(
																								e,
																								'displayName',
																							) &&
																							e.displayName !==
																								''
																								? e.displayName
																								: e.name}
																						</span>
																					</b>
																			  ))
																			: '-'}
																	</span>
																	{/* </b> */}
																</span>
															</div>
														</td>
														<td
															// className="all-other-column-fixed"
															onClick={this.props.handleShootClick}
														>
															<div className="project-general-box">
																<span className="crew-outer-container">
																	{/* <b
                                                className={
                                                    'starFilled' +
                                                    ' date-overlap' +
                                                    ' date-time-overlap'
                                                } */}
																	{/* // key={i} */}
																	{/* style={{
                                                    background: 'none',
                                                    borderRadius: 0,
                                                    border: 'none',
                                                    height: 20,
                                                    padding: 0,
                                                }}
                                            > */}
																	<span
																		className="crew-name-text"
																		style={{
																			color: '#e4e5e6',
																			display: 'flex',
																			flexDirection: 'column',
																			textTransform:
																				'capitalize',
																		}}
																	>
																		{_.size(
																			_.filter(
																				shoot.crewDetails,
																				{
																					role: 'cinematographer',
																					subRole:
																						'candid',
																				},
																			),
																		) > 0
																			? _.filter(
																					shoot.crewDetails,
																					{
																						role: 'cinematographer',
																						subRole:
																							'candid',
																					},
																			  ).map((e, i) => (
																					<b
																						className={
																							'starFilled' +
																							(e.dateOverlap
																								? ' date-overlap'
																								: '') +
																							(e.dateTimeOverlap
																								? ' date-time-overlap'
																								: '')
																						}
																						key={i}
																						style={{
																							background:
																								'none',
																							borderRadius: 0,
																							border: 'none',
																							height: 20,
																							padding: 0,
																						}}
																					>
																						<span
																							className="crew-name-text"
																							style={{
																								color: '#e4e5e6',
																							}}
																						>
																							{_.has(
																								e,
																								'displayName',
																							) &&
																							e.displayName !==
																								''
																								? e.displayName
																								: e.name}
																						</span>
																					</b>
																			  ))
																			: '-'}
																	</span>
																	{/* </b> */}
																</span>
															</div>
														</td>

														<td
															// className="all-other-column-fixed"
															onClick={this.props.handleShootClick}
														>
															<div className="project-general-box">
																<span className="crew-outer-container">
																	{/* <b
                                                className={
                                                    'starFilled' +
                                                    ' date-overlap' +
                                                    ' date-time-overlap'
                                                }
                                                // key={i}
                                                style={{
                                                    background: 'none',
                                                    borderRadius: 0,
                                                    border: 'none',
                                                    height: 20,
                                                    padding: 0,
                                                }}
                                            > */}
																	<span
																		className="crew-name-text"
																		style={{
																			color: '#e4e5e6',
																			display: 'flex',
																			flexDirection: 'column',
																			textTransform:
																				'capitalize',
																		}}
																	>
																		{/* {_.has(e, 'displayName') &&
                                                    e.displayName !== ''
                                                        ? e.displayName
                                                        : e.name} */}
																		{_.size(
																			_.filter(
																				shoot.crewDetails,
																				{
																					role: 'cinematographer',
																					subRole:
																						'traditional',
																				},
																			),
																		) > 0
																			? _.filter(
																					shoot.crewDetails,
																					{
																						role: 'cinematographer',
																						subRole:
																							'traditional',
																					},
																			  ).map((e, i) => (
																					<b
																						className={
																							'starFilled' +
																							(e.dateOverlap
																								? ' date-overlap'
																								: '') +
																							(e.dateTimeOverlap
																								? ' date-time-overlap'
																								: '')
																						}
																						key={i}
																						style={{
																							background:
																								'none',
																							borderRadius: 0,
																							border: 'none',
																							height: 20,
																							padding: 0,
																						}}
																					>
																						<span
																							className="crew-name-text"
																							style={{
																								color: '#e4e5e6',
																							}}
																						>
																							{_.has(
																								e,
																								'displayName',
																							) &&
																							e.displayName !==
																								''
																								? e.displayName
																								: e.name}
																						</span>
																					</b>
																			  ))
																			: '-'}
																	</span>
																	{/* </b> */}
																</span>
															</div>
														</td>
														<td
															// className="all-other-column-fixed"
															onClick={this.props.handleShootClick}
														>
															<div className="project-general-box">
																<div className="eq-mc-outer-container">
																	{shoot.equipments === null ||
																	_.size(shoot.equipments) ===
																		0 ? null : (
																		<span className="eq-mc-container">
																			<span
																				style={{
																					marginLeft:
																						'5px',
																					textTransform:
																						'capitalize',
																				}}
																			>
																				{`${_.size(
																					_.filter(
																						shoot.equipments,
																						{
																							isReceived: true,
																						},
																					),
																				)}
									/ ${_.size(shoot.equipments)}`}
																			</span>
																		</span>
																	)}
																</div>
															</div>
														</td>
														<td
															// className="all-other-column-fixed"
															onClick={this.props.handleShootClick}
														>
															<div className="eq-mc-outer-container">
																<span className="eq-mc-container">
																	<span
																		style={{
																			marginLeft: '5px',
																			textTransform:
																				'capitalize',
																		}}
																	>
																		{shoot.memoryCards ===
																			null ||
																		_.size(
																			shoot.memoryCards,
																		) === 0 ? null : (
																			<span className="eq-mc-container">
																				<span
																					style={{
																						marginLeft:
																							'5px',
																						textTransform:
																							'capitalize',
																					}}
																				>
																					{`${_.size(
																						_.filter(
																							shoot.memoryCards,
																							{
																								isReceived: true,
																							},
																						),
																					)}
									/ ${_.size(shoot.memoryCards)}`}
																				</span>
																			</span>
																		)}
																	</span>
																</span>
															</div>
														</td>
														<td
															// className="all-other-column-fixed"
															onClick={this.props.handleShootClick}
														>
															<div className="eq-mc-outer-container">
																<span className="eq-mc-container">
																	<span
																		style={{
																			marginLeft: '5px',
																			textTransform:
																				'capitalize',
																		}}
																	>
																		{_.map(
																			shoot.additionalServices,
																			(service) => {
																				return (
																					<span className="eq-mc-container text-12px">
																						{service.type
																							? service.type
																									.charAt(
																										0,
																									)
																									.toUpperCase() +
																							  service.type
																									.replace(
																										/([A-Z])/g,
																										' $1',
																									)
																									.slice(
																										1,
																									)
																							: null}
																					</span>
																				);
																			},
																		)}
																	</span>
																</span>
															</div>
														</td>
														<td
															className="wedding-details-column"
															onClick={this.props.handleShootClick}
														>
															<div className="additional-services-shoot-container">
																<span className="eq-mc-container text-12px"></span>
															</div>
														</td>
													</tr>
												);
											})}
											{/* </div> */}
										</tbody>
									)}
								</table>
							</InfiniteScroll>
						</div>
					</div>
				</div>
			</Modal>
		);
	}
}

export default withRouter(ShowShootOverviewDetails);
